import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { Layout, ProtectedRoute } from './components/layout';

// Home page
import { HomePage } from './pages/home';

// Auth pages
import { LoginPage, ForgotPasswordPage, RegisterPage } from './pages/auth';

// Dashboard
import { DashboardPage } from './pages/dashboard';

// Profile pages
import { ProfilePage, ChangePasswordPage } from './pages/profile';

// Admin pages
import { UsersPage, DepartmentsPage, RolesPage, PermissionsPage, OperationLogsPage } from './pages/admin';

// AI Tools
import { AIImagePage } from './pages/ai-image';
import { StableDiffusionPage } from './pages/stable-diffusion';

// Opinion pages
import { OpinionPage, AdminOpinionPage } from './pages/opinion';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/ai-image" element={<AIImagePage />} />
          <Route path="/stable-diffusion" element={<StableDiffusionPage />} />
          <Route path="/opinion" element={<OpinionPage />} />

          {/* Protected routes */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Layout>
                  <DashboardPage />
                </Layout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <Layout>
                  <ProfilePage />
                </Layout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/change-password"
            element={
              <ProtectedRoute>
                <Layout>
                  <ChangePasswordPage />
                </Layout>
              </ProtectedRoute>
            }
          />

          {/* Admin routes */}
          <Route
            path="/admin/users"
            element={
              <ProtectedRoute requireAdmin allowDepartmentManager>
                <Layout>
                  <UsersPage />
                </Layout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin/departments"
            element={
              <ProtectedRoute requireAdmin allowDepartmentManager>
                <Layout>
                  <DepartmentsPage />
                </Layout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin/roles"
            element={
              <ProtectedRoute requireAdmin>
                <Layout>
                  <RolesPage />
                </Layout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin/permissions"
            element={
              <ProtectedRoute requireAdmin>
                <Layout>
                  <PermissionsPage />
                </Layout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin/operation-logs"
            element={
              <ProtectedRoute requireSuperuser>
                <Layout>
                  <OperationLogsPage />
                </Layout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/management/opinions"
            element={
              <ProtectedRoute requireAdmin>
                <AdminOpinionPage />
              </ProtectedRoute>
            }
          />

          {/* 404 redirect to home */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
